import request from '@/utils/request'

export function getProductionImportLogs(params) {
  return request({
    url: '/api/produce/importlog/list',
    method: 'get',
    params
  })
}

export function getProductionImportLogDetail(id) {
  return request({
    url: `/api/produce/importlog/detail/${id}`,
    method: 'get'
  })
}

export function getProductionImportErrors(params) {
  return request({
    url: '/api/produce/importerror/list',
    method: 'get',
    params
  })
}

export function getProductionImportErrorDetails(params) {
  return request({
    url: '/api/produce/importerror/groupdetail',
    method: 'get',
    params
  })
}

export function getProductionImportErrorTypes() {
  return request({
    url: '/api/produce/importerror/errortypes',
    method: 'get'
  })
}
